import * as React from 'react'

class Accordion extends React.Component {
    constructor(props) {
        super(props)
        const {children, selectedIndex} = this.props

        this.index = typeof props.selectedIndex !== 'undefined' ? props.selectedIndex : -1
        this.closingIndex = -1;
        this.closeClicked = -1;
        this.force = false;
        this.nodes = []
        this.state = {
            //index: typeof props.selectedIndex !== 'undefined' ? props.selectedIndex : -1,
            //closingIndex: -1,
            heights: React.Children.map(
                children,
                (child, index) => (index === selectedIndex ? 'auto' : 0)
            )
        }
        
    }

    componentDidMount() {

    }

    UNSAFE_componentWillReceiveProps(props) {
        //console.log("componentWillReceiveprops", props);
        // const {selectedIndex} = props
        // if (typeof selectedIndex !== 'undefined' && this.index !== selectedIndex) {
        //     this.toggle(selectedIndex, false, true)
        //     console.log("componentWillReceiveprops", props, this.index,  selectedIndex);
        // }
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const {selectedIndex} = this.props;
        if (this.index === -1 && this.closeClicked > -1){
            this.closeClicked = 1;   
        }
        else if (typeof selectedIndex !== 'undefined' && this.index !== selectedIndex && selectedIndex > -1) {
            //console.log("componentDidUpdate - index=",this.index, this.props.displayName,selectedIndex);
            this.toggle(selectedIndex, false, false);
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timeout)
    }

    setHeight(index, height, callback) {
        const heights = this.state.heights.slice();
        heights[index] = height;
        this.setState({heights}, callback);
    }

    open(index) {
        clearTimeout(this.timeout);
        this.setHeight(index,
            this.nodes[index].children[1].children[0].offsetHeight,
            () => {
                this.timeout = setTimeout(() => {
                    this.setHeight(index, 'auto');
                    if (this.props.callback) {
                        //console.log("run props.callback open, index:", index);
                        this.props.callback(this.props.name, index);
                    }
                }, this.props.transitionDuration)
            });
    }

    close(index) {
        clearTimeout(this.timeout);
        //console.log("closing", index);
        if (!this.force && this.props.transitionDuration > 0) {
            setTimeout(() => {
                this.setHeight(index,
                    0,
                    () => {
                        this.timeout = setTimeout(() => {
                                if (this.props.callback) {
                                    //console.log("run props.callback, close");
                                    this.props.callback(this.props.name, -1);
                                }
                            }
                            , 0); //this.props.transitionDuration);
                    });

            }, 1); // react-render issue on collapsing fixed by using a setTimeout 
        } else {
            //console.log("close, immedietly");
            this.setHeight(index, 0);

        }
    }

    setFixedHeightOnCurrentlyOpenedItem() {
        return new Promise(resolve => {
            if (this.closingIndex > -1) {
                if (this.nodes[this.closingIndex]) {
                    //console.log("setFixedHeight", this.nodes[this.index].children[1].children[0], "index: ", this.index);
                    this.setHeight(
                        this.closingIndex,
                        this.nodes[this.closingIndex].children[1].children[0].offsetHeight,
                        resolve
                    )
                } else {
                    resolve();
                }
            } else {
                //console.log("setFixedHeight -", this.index)
                resolve()
            }
        })
    }

    toggle(index, click, force, titleOpenClick) {
        const {onChange, changeOnClick, onTitleOpenClick} = this.props
        clearTimeout(this.timeout)

        this.force = force;

        if (click) {
            if (onChange) {
                onChange(index, this.index !== index, this.index !== index ? index : -1)
            }
            if (!changeOnClick) return
        }

        


        if (this.index > -1) { // added to render closing class on accordion-item (
            this.closingIndex = this.index;
            this.closeClicked = this.index;
        }

        // First, set a fixed height on the currently opened item, for collapse animation to work
        if (index > -1 && (index !== this.index || force)) {
            this.index = index
        }
        else
        {
            this.index = -1
        }

        this.setFixedHeightOnCurrentlyOpenedItem().then(() => {
            if ((!force && this.closingIndex > -1) || (force && index === -1 && this.closingIndex > -1)) {
                this.close(this.closingIndex)
            }

            if (this.index > -1) {
                //this.index = index
                
                if (click && titleOpenClick && this.index > -1) {
                    titleOpenClick();
                }
                
                this.open(index)
            } else {
                //this.index = -1
                this.closingIndex = -1;
            }
        })

    }

    render() {

        const {transitionDuration, transitionTimingFunction, className, openClassName, closingClassName} = this.props
        const nodes = React.Children.toArray(this.props.children).filter(x => x).map((child, index) => {
            
            const isAccordionPanel = child.props['data-headerclass'];
            // const titleOpenClickUrl = child.props['data-titleopenclick'];

            const onTitleOpenClick = child.props['data-ontitleopenclick'];


            // console.log("RENDER Accordion", index, child.props['data-header'], isAccordionPanel)
            return (

                isAccordionPanel
                    ? <div
                        key={index}
                        ref={div => {
                            this.nodes[index] = div
                        }}
                        className={(this.index === index ? openClassName : '') + (this.closingIndex === index ? (' ' + closingClassName) : '') + ' ' + child.props['data-wrapperclass']}
                    >

                        <div className={child.props['data-headerclass']} onClick={() => this.toggle(index, true, false, onTitleOpenClick)}>{child.props['data-header']}
                            {child.props['data-subheader'] && <span>{child.props['data-subheader']}</span>}
                        </div>

                        <div style={{
                            overflow: 'hidden',
                            transition: !this.force ? `height ${transitionDuration}ms ${transitionTimingFunction}` : null,
                            height: this.state.heights[index]
                        }}>{child}</div>
                    </div>
                    : child
            )
        })

        return <div className={className}>{nodes}</div>
    }
}

Accordion.defaultProps = {
    transitionDuration: 500,
    transitionTimingFunction: 'ease',
    openClassName: 'open',
    closingClassName: 'closing',
    changeOnClick: true
}

export default Accordion